// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZYdF6","page":"styles_page__3XeT8","main":"styles_main__YImB9"};